import React from "react";
import SEO from "../Components/SEO";
import Card2 from "../Images/Headers/publicity_2.jpg";
import "./Article.css";
import Breadcrumb from "react-bootstrap/Breadcrumb";

export function BiodigesterBusinessCase() {
  return (
    <div className="art-page">
      <SEO
        title="Assessment of Business Case for Household Bio-Digesters"
        description="CIRCODU assessed household bio-digester economics for 10 model farmers and 5 construction companies across 12 districts, documenting fuel cost savings, time savings for women, and agricultural productivity benefits."
        keywords="bio-digester, business case, household energy, biogas, Uganda, agricultural productivity, fuel cost savings, time savings, bio-slurry, biogas construction companies, economic assessment, CIRCODU, bio-digester business case Uganda, household bio-digester economics Uganda, biogas benefits Uganda, fuel cost savings Uganda, time savings Uganda, agricultural productivity Uganda, bio-slurry benefits Uganda, biogas construction companies Uganda"
        url="/Assessment-of-Business-Case-for-Household-Bio-Digesters-Uganda-BSUL"
        datePublished="2019-12-01"
      />

      <div className="art-hero">
        <div className="art-hero__image">
          <img src={Card2} alt="News and Events Header" />
        </div>
        <div className="art-hero__overlay">
          <h4 className="art-hero__label">News &amp; Events</h4>
          <Breadcrumb>
            <Breadcrumb.Item className="text1" href="/">
              Home
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">Publicity</Breadcrumb.Item>
            <Breadcrumb.Item
              className="text1"
              href="/publicity/news-and-events"
            >
              News &amp; Events
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">
              Assessment of Business Case for Household Bio-Digesters — Uganda
            </Breadcrumb.Item>
          </Breadcrumb>
        </div>
      </div>

      <section className="art-section border-bottom">
        <div className="container">
          <div className="art-content">
            <div className="art-date">
              <span className="art-date__dot" />
              December 01, 2019
            </div>
            <h1 className="art-title">
              Assessment of Business Case for Household Bio-Digesters — Uganda
              (BSUL)
            </h1>
            <div className="texty">
              <h2 className="art-subheading">Overview</h2>
              <p>
                In late 2019, CIRCODU conducted a business case assessment for
                household bio-digesters in Uganda, commissioned by{" "}
                <strong>Biogas Solutions Uganda Limited (BSUL)</strong>. The
                study was designed to quantify and document the tangible
                economic value that bio-digesters generate — both for individual
                household users and for the construction companies that build
                them — through carefully selected case studies drawn from across
                Uganda.
              </p>
              <p>
                Bio-digesters convert organic waste — including kitchen scraps,
                animal manure, and agricultural residues — into biogas for
                cooking and lighting, and bio-slurry for use as fertiliser.
                Despite their clear potential to simultaneously address energy
                access, waste management, and agricultural productivity,
                bio-digesters have often struggled to attract investment due to
                a lack of rigorous economic evidence from real Ugandan
                households.
              </p>
              <h2 className="art-subheading">CIRCODU's Role</h2>
              <p>
                The assessment was structured around{" "}
                <strong>10 model farmer households</strong> and{" "}
                <strong>5 biogas construction companies</strong> operating
                across <strong>12 districts</strong> spanning Uganda's eastern,
                central, southern, and western regions. For each household case
                study, CIRCODU documented:
              </p>
              <ol>
                <li>
                  Fuel cost savings from reduced wood and charcoal purchases.
                </li>
                <li>
                  Time savings from reduced fuel collection — a benefit falling
                  disproportionately on women and girls.
                </li>
                <li>
                  Agricultural productivity gains from bio-slurry fertiliser
                  use.
                </li>
                <li>Health improvements from reduced indoor air pollution.</li>
              </ol>
              <p>
                For the construction company case studies, CIRCODU analysed
                revenue streams, operating costs, and the commercial
                sustainability of the biogas enterprise model.
              </p>
              <h2 className="art-subheading">Significance</h2>
              <p>
                By building a rigorous financial and economic case from real
                household and business data, CIRCODU's assessment gave BSUL and
                its development partners concrete evidence to use in advocacy,
                investor communications, and programme design — demonstrating
                that biogas is not merely an environmental technology but a
                sound economic investment for Ugandan households and
                entrepreneurs.
              </p>
            </div>
            <div className="art-cta">
              <p>
                For more information about CIRCODU's renewable energy
                assessments and biogas research, contact us at{" "}
                <a href="mailto:info@circodu.org.ug">info@circodu.org.ug</a> or
                call <a href="tel:+256392004309">+256 (0) 392 004 309</a> /{" "}
                <a href="tel:+256782433627">+256 (0) 782 433 627</a>
              </p>
            </div>
            <a href="/publicity/news-and-events" className="art-back">
              ← Back to News &amp; Events
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
